export type UiColor =
  | "gray"
  | "orange"
  | "lightGray"
  | "black"
  | "darkRed"
  | "red"
  | "lightRed"
  | "lighterRed"
  | "lightestRed"
  | "lightBlue"
  | "darkerGray"
  | "darkGray"
  | "hoverRed"
  | "white"
  | "lighterGray"
  | "darkestGray"
  | "lightestGray"
  | "veryLightGray"
  | "blue"
  | "blueDark"
  | "veryLightBlue"
  | "darkerRed"

const colorsMapping: { [k in UiColor]: string } = {
  lightestGray: "#ADBBBF",
  gray: "#4E5B5E",
  orange: "#F77769",
  lightGray: "#D9E1E3",
  black: "#343D3F",
  darkRed: "#D31A06",
  darkerRed: "#B11100",
  red: "#EE2B16",
  lightRed: "#F77769",
  lighterRed: "#FFB5AC",
  lightestRed: "#FFECE9",
  hoverRed: "#fd503d",
  lightBlue: "#F6FBFC",
  darkerGray: "#515a5c",
  darkGray: "#1f2323",
  lighterGray: "#88969a",
  white: "#fff",
  darkestGray: "#181E1F",
  veryLightGray: "#515A5C",
  blue: "#00d8ff",
  blueDark: " #00587D",
  veryLightBlue: "#EEF4F5",
}

export const uiColorToBaseColor = (color: UiColor): string =>
  colorsMapping[color]
